import { FC } from "react";
import { Content, isFilled } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/atoms/buttons";
import Image from "next/image";
import AppLink from "@/components/atoms/Links/AppLink";

export type CtaProps = SliceComponentProps<Content.CtaSlice>;

const Cta: FC<CtaProps> = ({ slice }) => {
  const { cta_image, content, cta_button } = slice.primary;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={cn(
        "relative container mt-1 h-full min-h-[448px] w-full overflow-hidden px-11 after:absolute after:inset-0 after:z-20 after:bg-black/60 min-[1595px]:rounded-lg"
      )}
    >
      {isFilled.image(cta_image) && (
        <Image fill src={cta_image.url} alt={cta_image.alt || ""} className="absolute object-cover" />
      )}{" "}
      <div className="font-cabinet-grotesk absolute top-1/2 left-1/2 z-30 mx-auto flex w-full max-w-[1394px] -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center gap-7.5 text-white">
        {isFilled.richText(content) && (
          <PrismicRichText
            field={content}
            components={{
              heading2: ({ children }) => (
                <h2 className="text-center text-2xl font-medium max-xl:mx-12.5 min-[404px]:text-3xl lg:text-4xl">
                  {children}
                </h2>
              ),
              em: ({ children }) => <em className="font-light not-italic opacity-70">{children}</em>,
            }}
          />
        )}
        {isFilled.link(cta_button) && (
          <AppLink
            field={cta_button}
            className={cn(
              buttonVariants({ size: "md" }),
              "bg-blue-brand h-11 text-lg font-bold transition-all duration-300 ease-in-out"
            )}
          />
        )}
      </div>
    </section>
  );
};

export default Cta;
